import { useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { api } from '../lib/api.js'
import { homeFor, useAuth } from '../lib/auth.jsx'
import { SubmitButton } from '../components/Ui.jsx'

const POINTS = [
  'Batch listings with PCR clearance and stress-test scores',
  'Date matching inside the strict target → target +2 day window',
  'Mandatory 100-animal sample balloon before every dispatch',
  'Liaison-escorted oxygenated transport to the pond'
]

export default function Login () {
  const { user, loading, signIn } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)
  const [demo, setDemo] = useState([])
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    api.get('/auth/demo-credentials')
      .then(d => setDemo(d.accounts || []))
      .catch(() => setDemo([]))
  }, [])

  if (!loading && user) return <Navigate to={location.state?.from || homeFor(user)} replace />

  const submit = async e => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const signed = await signIn(username, password)
      navigate(location.state?.from || homeFor(signed), { replace: true })
    } catch (err) {
      setError(err.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-shell">
      <div className="login-art">
        <div className="login-mark">
          <div className="glyph">🦐</div>
          <div>
            <h1>Aqua Platform</h1>
            <div className="place">Kakinada · Andhra Pradesh</div>
          </div>
        </div>

        <p className="lede">
          The seed desk for shrimp hatcheries across the Tuni – Kakinada – U. Kothapalli belt.
          Hatcheries publish their production batches; the operator desk matches farmers to them
          by stocking date, PL stage and haul distance.
        </p>

        <ul className="login-points">
          {POINTS.map(p => (
            <li key={p}><span className="tick">✓</span><span>{p}</span></li>
          ))}
        </ul>

        <div className="login-foot">Seed desk · hatchery portal · field liaison</div>
      </div>

      <div className="login-form">
        <div className="inner">
          <div className="login-card">
            <h2>Sign in</h2>
            <p className="sub">Accounts are issued by the platform admin.</p>

            {error && <div className="alert error" style={{ marginBottom: 16 }}>{error}</div>}

            <form onSubmit={submit}>
              <label className="f">
                <span>Username</span>
                <input
                  type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  autoFocus
                  autoComplete="username"
                  required
                />
              </label>
              <label className="f">
                <span>Password</span>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </label>
              <SubmitButton busy={busy} className="btn primary block" type="submit">Sign in</SubmitButton>
            </form>

            <div className="login-help">
              <span className="k">?</span>
              <span>
                Forgotten your password? Call the platform admin — resets are issued at the admin
                desk and handed over offline.
              </span>
            </div>
          </div>

          {demo.length > 0 && (
            <div className="demo-creds">
              <div className="dhead">Demo accounts · click to fill</div>
              <div className="dlist">
                {demo.map(d => (
                  <button
                    type="button"
                    key={d.username}
                    className="drow"
                    onClick={() => { setUsername(d.username); setPassword(d.password) }}
                  >
                    <span className="role">{d.role}</span>
                    <span className="u">{d.username}</span>
                    <span className="p">{d.password}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
